import type React from 'react'

type Props = {
  size?: number
}

const IconArrowDownLine: React.FC<Props> = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9219 13.5312H3.07812C2.66797 13.5312 2.375 13.8242 2.375 14.2344C2.375 14.6445 2.66797 14.9375 3.07812 14.9375H12.9219C13.3027 14.9375 13.625 14.6445 13.625 14.2344C13.625 13.8535 13.3027 13.5312 12.9219 13.5312ZM11.2227 6.96875L8.70312 9.66406V2.54492C8.70312 2.13477 8.38086 1.8125 8 1.8125C7.58984 1.8125 7.29688 2.13477 7.29688 2.54492V9.66406L4.74805 6.96875C4.60156 6.82227 4.42578 6.76367 4.25 6.76367C4.07422 6.76367 3.89844 6.82227 3.75195 6.93945C3.45898 7.20312 3.45898 7.64258 3.72266 7.93555L7.47266 11.9199C7.73633 12.2129 8.23438 12.2129 8.49805 11.9199L12.248 7.93555C12.5117 7.64258 12.5117 7.20312 12.2188 6.93945C11.9258 6.67578 11.4863 6.67578 11.2227 6.96875Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconArrowDownLine
